import React, {Component} from 'react';
import { Container, Row, Col, Tab, Nav, Form, Button, Spinner} from "react-bootstrap";
import { FaSave, FaRegTrashAlt, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from '../lib/Crypt';
import Loader from "./LoaderModal";
import swal from 'sweetalert';
import C from '../lib/Config';

export default class AddReportParameter extends Component {
    constructor(props) {
        super(props);
        this.state = { range: '', redirect : false, reportID: '', reportParameter: '', reportList: [], reportParamArr: [], reportXParamId: 0   };
        this.handleChange = this.handleChange.bind(this); 
    }
    
    componentDidMount() {
        this.reportListApiCall();
        this.reportParameterListApiCall();
    }

    handleChange(event){
        if(event.target.name === 'range'){
            this.setState({range: event.target.value});
        }
        if(event.target.name === 'reportID'){
            this.setState({reportID: event.target.value});
        }
        if(event.target.name === 'reportParameter'){
            this.setState({reportParameter: event.target.value});
        }
    } 

    reportParameterListApiCall() {
        return fetch(C.getUrl() + '/reportParamMst/getReportParameterForSelect')
        .then(res => res.json())
        .then(res => {
            let data = JSON.parse(res.message);
            var arr = [{ key: Crypt.getUniqueKey('0'), id: 'DEFAULT', label: '- Select Report Parameter -' }];
            data.map((item, index) => {
                let jsonList = new Object();
                jsonList['key'] = Crypt.getUniqueKey(index);
                jsonList['id'] = item.selectionId;
                jsonList['label'] = item.selectionValue;
                arr.push(jsonList);
            });
            this.setState({ reportParamArr: arr });
        })
        .catch(err => {
            swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    reportListApiCall = async () => {
        fetch(C.getUrl() + '/reportMst/findAll/')
            .then(res => res.json())
            .then(res => {
                //console.log('--> REPORT MASTER STATUS : ' + res.status)
                let data = JSON.parse(res.message);
                //console.log('--> REPORT MASTER - MESSAGE DATA: ' + JSON.stringify(data));
                if (data !== null) {
                    let reportData = [{ key: Crypt.getUniqueKey('0'), id: 'DEFAULT', label: '- Select Report -' }];
                    data.map((item, index) => {
                        let jsonList = new Object();
                        jsonList['key'] = Crypt.getUniqueKey(index);
                        jsonList['id'] = item.reportId + '';
                        jsonList['label'] = item.reportName;
                        reportData.push(jsonList);
                    });
                    //console.table(reportData)
                   // this.setState.reportList(reportData)
                    this.setState({ reportList: reportData }); 
                }

            })
            .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
            });
    }



    saveReportParameterMapping(event){
        let data = {
            normalRange: this.state.range,
            reportXParamId: this.state.reportXParamId,
            activeInd: 'Y',
            createdDt: new Date(),
            updatedDt: new Date(),
            createdByIdUser: {
                userId: localStorage.getItem('userId')
            },
            updatedByIdUser: {
                userId: localStorage.getItem('userId')
            },
            reportParameterMstDto: {
                reportParamId: this.state.reportParameter
            },
            reportMasterDto: {
                reportId: this.state.reportID
            }
            
        }
        console.log('-->NEWWWWWWW: ' + JSON.stringify(data))
        return fetch(C.getUrl() + '/reportXParamMst/saveUpdate', {
            method: 'POST',
            mode: 'cors',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            let obj = res;
            let error = obj.subErrors;
            if (error !== null && error !== "") {
                swal({ title: "Warning!", text: "Error : " + error, icon: "error", buttons: false, timer: 2000, });
            } else {
                this.setState({ saveLoader: true });
                setTimeout(() => { this.setState({ saveLoader: false }) }, 3000)
                swal({ title: "Lab Test Parameter Mapping Saved Successfully", icon: "success", buttons: false, timer: 2000, });
                setTimeout(() => { this.setState({ key: 'fourth'}) }, 4000)
                this.setState({ redirect : true });
            }
        })
        .catch(err => {
                swal({ title: "Warning!", text: "Error : " + err, icon: "error", buttons: false, timer: 2000, });
        });
    }

    render() {
        const { reportList, reportParamArr  } = this.state;
        const _this = this;
        const { redirect } = this.state;
        return (
            <div className="d-flex" id="wrapper">
                {<Side />}
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        {<Top />}
                        <Container fluid>
                            <div className="app-content">
                                <section className="section">
                                    <Link to="/ReportParamMappingMst" className="btn btn-light"><FaArrowLeft className='fs-18' size='2.0rem' style={{verticalAlign: 'baseline'}}/> </Link> 
                                    <h3 className="fs-18 ml-3 header_title text-black mb-4">Add Lab Test Report Parameter</h3>
                                    <div className="dropdown-divider pb-2"></div>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Report </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="select" id="" name='reportID' value={this.state.reportID} onChange={this.handleChange}>
                                                {
                                                    reportList.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                            </Form.Control>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Report Paramter </Form.Label>
                                        <Col sm="9">
                                            <Form.Control as="select" id="" name='reportParameter' value={this.state.reportParameter} onChange={this.handleChange}>
                                                {
                                                    reportParamArr.map((item, i) => {
                                                        return (
                                                            <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                        );
                                                    })
                                                }
                                            </Form.Control>
                                        </Col>
                                    </Form.Group>
                                    <Form.Group as={Row}>
                                        <Form.Label column sm="3"> Healthy Range </Form.Label>
                                        <Col sm="9">
                                            <Form.Control type='text' placeholder='' name='range' onChange={this.handleChange} value={this.state.range} />
                                        </Col>
                                    </Form.Group>
                                    <Row>
                                        <Col lg='12'>
                                            <div className="form-button text-center">
                                                <Button type="button" className="btn pt-2 pb-2 btn-secondary" onClick={this.saveReportParameterMapping.bind(this)}>
                                                    {this.state.saveLoader && (
                                                        <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                    )}
                                                    {!this.state.saveLoader && (
                                                        <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                    )}
                                                    Save
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </section>
                            </div>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}